interface ProfileStatCardProps {
  value: string | number;
  label: string;
  className?: string;
}

export function ProfileStatCard({
  value,
  label,
  className = "",
}: ProfileStatCardProps) {
  return (
    <div
      className={`flex min-w-[111px] flex-1 basis-[fit-content] flex-col gap-2 rounded-3xl border border-gray-200 dark:border-white/10 bg-card-light dark:bg-black/20 p-3 items-center text-center ${className}`}
    >
      <p className="text-gray-900 dark:text-white tracking-light text-2xl font-bold leading-tight">
        {value}
      </p>
      <div className="flex items-center gap-1.5">
        <p className="text-gray-500 dark:text-gray-400 text-sm font-normal leading-normal">
          {label}
        </p>
      </div>
    </div>
  );
}
